import type { FooterIconConfig } from '~/config/types/webshopConfiguration';
import { memo } from 'react';
import { FaYoutube, FaLinkedin, FaFacebook, FaRegEnvelope, FaPhone, FaInstagram, FaWhatsapp } from 'react-icons/fa';

export const FooterIcon = memo(({ icon, size }: { icon: FooterIconConfig, size?: number}) => {
  if (icon === 'phone') {
    return <FaPhone size={size ?? 24}/>;
  }
  if (icon === 'mail') {
    return <FaRegEnvelope size={size ?? 24} />;
  }
  if (icon === 'facebook') {
    return <FaFacebook size={size ??24} />;
  }
  if (icon === 'instagram') {
    return <FaInstagram size={size ?? 24}/>;
  }
  if (icon === 'youtube') {
    return <FaYoutube size={size ?? 30} />;
  }
  if (icon === 'linkedin') {
    return <FaLinkedin size={size ?? 24} />;
  }
  if (icon === 'whatsapp') {
    return <FaWhatsapp size={size ?? 24} />;
  }
  return null;
  }
)

FooterIcon.displayName = 'FooterIcon';